import { styled } from '@linaria/react'
import React, { FC } from 'react'
import { colors } from '../styles/colors'
import { Typography } from './Typography'

export const PercentagePresets: FC<{
  values: number[]
  selectedValue: number
  onChange: (value: number) => void
  disabled?: boolean
  className?: string
}> = ({ values, selectedValue, onChange, disabled = false, className }) => {
  return (
    <Container className={className}>
      {values.map(value => (
        <PresetButton
          type="button"
          key={value}
          selected={value === selectedValue}
          disabled={disabled}
          onClick={() => !disabled && onChange(value)}
        >
          <Typography
            fontSize={14}
            fontWeight={500}
            color={value === selectedValue ? colors.white : colors.secondary}
          >
            {value}%
          </Typography>
        </PresetButton>
      ))}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  gap: 4px;
  width: 100%;
  padding: 4px 0;
`

const PresetButton = styled.button<{ selected: boolean; disabled: boolean }>`
  flex: 1;
  background: ${props => (props.selected ? colors.secondary : 'transparent')};
  border: 1px solid ${colors.secondary};
  border-radius: 100px;
  padding: 4px 16px;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;
  user-select: none;

  &:hover:not(:disabled) {
    background: ${props =>
      props.selected ? colors.secondary : colors.grey100};
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.5;
  }
`
